module.exports = __webpack_public_path__ + "static/media/AdultsSelected.e8d54e64.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/AdultsSelected.png
// module id = 3830
// module chunks = 0